module.exports = __webpack_public_path__ + "static/media/tier-4.e3c9efb7.jpg";